import type { GiftcardCartItem } from '~/composables/types/cart'

const parseGiftcardWithoutEvent = (
  selectedAmount: any,
  name: string,
  supplierId: string | undefined | null,
  id?: string,
  supplierName?: string
): GiftcardCartItem => {
  return {
    type: 'GIFT_CARD',
    giftcardType: 'VALUE',
    giftcardAddon: 'PDF',
    title: name || 'Giftcard',
    price: selectedAmount,
    thumbnail: '/_nuxt3-static/promo-cards/giftbox.webp',
    quantity: 1,
    giftcardId: id || 'giftcard',
    ...(supplierId && { supplierId }),
    supplier: supplierName,
  }
}

export default parseGiftcardWithoutEvent
